import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import { toast } from 'react-toastify';
import { isIPad13 } from "react-device-detect";

import AppEmulationDeviceListModal from "./AppEmulationDeviceListModal";
import AppEmulationIFrame from "./AppEmulation";
import EndSessionConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";
import Spinner from "COMPONENTS/Spinner/Spinner";

import { getMessage } from "CONFIG/i18n";
import { USER_ROLES, Modules } from "UTILS/Constants";
import { isIphone13OrHigher } from "UTILS/Utility";

import { getCustomerId, selectUserName } from "COMPONENTS/MainLayout/selectors";
import { selectSessionKey, selectUniqueId } from "../../Routes/selectors";
import { selectUserRole } from "../Whiteboard/selectors";
import {
  getAppEmulationPermissionReply,
  getAppEmulationSessionActive,
  getAppEmulationIFrameUrl
} from "./AppEmulationSelector";
import { appEmulationAction } from "CONFIG/ActionFactory";
import { isIOS, isSafari } from "react-device-detect";

class AppEmulationContainer extends Component {
  constructor(props) {
    super(props);
    this.iFrame = React.createRef();
    this.state = {
      data: {
        osInfoArray: [],
        deviceInfoArray: [],
        appEmulationApplications :[]
      },
      showIFrameModal: false,
      appEmulationUrl: null,
      showEndSessionConfirmationModal: false,
      spinnerVisibility: false
    };
  }
  componentDidMount() {
    let event = "beforeunload";
    if (isIphone13OrHigher() || isIPad13) {
      event = "pagehide";
    }
    window.addEventListener(event, this.unload);
    if (
      this.props.customerId &&
      this.props.modules.includes(Modules.APP_EMULATION)
    ) {
      this.setState({spinnerVisibility: true})
      appEmulationAction.getDeviceInfo(this.props.customerId).then(
        response => {
          this.setState({ data: response.data, spinnerVisibility: false });

        },
        error => {
          console.log("error :", error);
          this.setState({spinnerVisibility: false})
        }
      );
    }
  }

  unload = e => {
    if (this.iFrame.current) {
      this.iFrame.current.postMessageForWindow();
    }
    if(this.state.showEndSessionConfirmationModal){
      this.setState({showEndSessionConfirmationModal: false})
    }
  };

  handleSubmitClick = (data, errorCallBack) => {
    data.userName = this.props.userName;
    data.sessionKey = this.props.sessionKey;
    data.uniqueId = this.props.uniqueId;
    data.customerId = this.props.customerId;
    data.lang = this.props.selectedLanguage;
    appEmulationAction.startAppEmulationSession(data).then(
      response => {
        this.props.toggle();
        this.setState({
          appEmulationUrl: response.data.appEmulationUrl,
          showIFrameModal: true
        }, this.props.setAppEmulationStatus(true));
        this.props.toggle();
        errorCallBack(false);
        // appEmulationAction.setAppEmulationIFrameUrl(response.data.appEmulationUrl);
        appEmulationAction.setAppEmulationSessionStatusAction(true);
      },
      error => {
        errorCallBack(error.code);
      }
    );
  };

  joinSession = () => {
    let data = {
      userName: this.props.userName,
      sessionKey: this.props.sessionKey,
      uniqueId: this.props.uniqueId,
      customerId: this.props.customerId
    };

    appEmulationAction.joinAppEmulationSession(data).then(
      response => {
        this.setState({
          appEmulationUrl: response.data.appEmulationUrl,
        });
      },
      error => {
        toastr.error(getMessage(error.code));
      }
    );
  };

  endSession = () => {
    let data = {
      sessionKey: this.props.sessionKey,
      uniqueId: this.props.uniqueId
    };
    appEmulationAction.endAppEmulationSession(data).then(
      response => {
        this.setState({
          showIFrameModal: false
        }, this.props.setAppEmulationStatus(false));
      },
      error => {
        toastr.error(getMessage(error.code));
      }
    );
    appEmulationAction.endAppEmulationSessionAction();
    appEmulationAction.setAppEmulationSessionStatusAction(false);
  };

  leaveSession = () => {
    let data = {
      sessionKey: this.props.sessionKey,
      uniqueId: this.props.uniqueId
    };
    appEmulationAction.endAppEmulationSession(data).then(
      response => { this.setState({showEndSessionConfirmationModal: false })},
      error => {
        toastr.error(getMessage(error.code));
      }
    );
    appEmulationAction.updateAppEmulationPermissionReply(false);
    appEmulationAction.updateAppEmulationPermissionRequest(false);
  };

  iFrameToggle = () => {
    this.setState({
      showIFrameModal: false
    });
  };

  toggleConfirmationPopUp = flag => {
    this.setState({ showEndSessionConfirmationModal: flag });
  };

  sessionEndAndLeave = () => {
    if (this.iFrame.current) {
      let postMessageFlag = this.iFrame.current.postMessageForWindow();
      if (postMessageFlag) {
        USER_ROLES.AGENT === this.props.role ? this.endSession() : setTimeout(this.leaveSession, 500);
      }
      this.toggleConfirmationPopUp(false);
    }
  };

  componentDidUpdate(prevProps){
    if(this.props.appEmulationPermisssionReply !== prevProps.appEmulationPermisssionReply) {

      if(prevProps.appEmulationPermisssionReply && !this.props.appEmulationPermisssionReply) {
        this.setState({
          showEndSessionConfirmationModal: false
        });
      }

      if(this.props.role === USER_ROLES.USER && this.props.appEmulationPermisssionReply) {
        this.joinSession();
      }
    }
  }

  componentWillUnmount() {
    appEmulationAction.updateAppEmulationPermissionReply(false);
    appEmulationAction.updateAppEmulationPermissionRequest(false);
    toast.dismiss();
    //toast.removeByType("success");
    //toast.removeByType("error");
  }

  render() {
    return (
      <>
      <Spinner showSpinner={this.state.spinnerVisibility} />
        {this.state.showEndSessionConfirmationModal &&(
            
          <EndSessionConfirmationModal
            show={true}
            isDoubleButton={true}
            handleNoClick={() => {
              this.toggleConfirmationPopUp(false);
            }}
            handleYesClick={() => {
              this.sessionEndAndLeave();
            }}
            message={
              USER_ROLES.AGENT === this.props.role
                ? getMessage("END_APP_EMULATION_SESSION_CONFIRMATION_TEXT")
                : getMessage("LEAVE_APP_EMULATION_SESSION_CONFIRMATION_TEXT")
            }
          />

        )}
        <AppEmulationDeviceListModal
          toggle={this.props.toggle}
          show={this.props.show}
          deviceInfo={this.state.data || {}}
          handleSubmitClick={this.handleSubmitClick}
          selectedLanguage={this.props.selectedLanguage}
          checkParticipantsAvailable={this.props.checkParticipantsAvailable}
        />
        {this.props.role === USER_ROLES.AGENT && this.state.appEmulationUrl ? (
          <AppEmulationIFrame
            show={this.state.showIFrameModal}
            appEmulationUrl={this.state.appEmulationUrl}
            role={this.props.role}
            toggle={this.toggleConfirmationPopUp}
            ref={this.iFrame}
          />
        ) : this.props.role === USER_ROLES.USER &&
          this.props.appEmulationPermisssionReply ? (<AppEmulationIFrame
            show={this.props.appEmulationPermisssionReply}
            appEmulationUrl={this.state.appEmulationUrl}
            role={this.props.role}
            joinSession={this.joinSession}
            toggle={this.toggleConfirmationPopUp}
            ref={this.iFrame}
          />) : null}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    customerId: getCustomerId(state),
    selectedLanguage: state.LanguageReducer.language,
    userName: selectUserName(state),
    sessionKey: selectSessionKey(state),
    uniqueId: selectUniqueId(state),
    role: selectUserRole(state),
    isAppEmulationSessionActive: getAppEmulationSessionActive(state),
    appEmulationUrl: getAppEmulationIFrameUrl(state),
    appEmulationPermisssionReply: getAppEmulationPermissionReply(state)
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AppEmulationContainer);
